(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["terence-brand-story-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedRoots = new WeakMap();
    const init = (root) => {
      const track = root.querySelector('[data-story-track]');
      const allSlides = [...root.querySelectorAll('[data-story-slide]')];
      const allDots = [...root.querySelectorAll('[data-story-dot]')];
      if (!track || !allSlides.length || initializedRoots.has(root)) return;
      initializedRoots.set(root,()=>{window.removeEventListener('resize',resize);clearTimeout(scrollTimer);});
      root.dataset.storyReady = 'true';
      const visibleItems = (items) => items.filter((item) => getComputedStyle(item).display !== 'none');
      let index = 0;
      const update = (next, moveViewport = true) => {
        const slides = visibleItems(allSlides);
        const dots = visibleItems(allDots);
        if (!slides.length) return;
        const mobileV70 = root.classList.contains('terence-brand-story--v70') && window.matchMedia('(max-width: 749px)').matches;
        index = mobileV70 ? Math.max(0, Math.min(next, slides.length - 1)) : (next + slides.length) % slides.length;
        const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        if (mobileV70) {
          track.style.transform = 'none';
          if (moveViewport) root.querySelector('.terence-brand-story__scene-viewport')?.scrollTo({ left: step * index, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } else {
          track.style.transform = `translateX(${-step * index}px)`;
        }
        allSlides.forEach((slide) => slide.classList.remove('is-current'));
        slides[index]?.classList.add('is-current');
        allDots.forEach((dot) => { dot.classList.remove('is-active'); dot.setAttribute('aria-selected', 'false'); });
        dots[index]?.classList.add('is-active');
        dots[index]?.setAttribute('aria-selected', 'true');
        const previous = root.querySelector('[data-story-prev]');
        const following = root.querySelector('[data-story-next]');
        if (previous) previous.disabled = mobileV70 && index === 0;
        if (following) following.disabled = mobileV70 && index === slides.length - 1;
      };
      root.querySelector('[data-story-prev]')?.addEventListener('click', () => update(index - 1));
      root.querySelector('[data-story-next]')?.addEventListener('click', () => update(index + 1));
      allDots.forEach((dot) => dot.addEventListener('click', () => update(visibleItems(allDots).indexOf(dot))));

      const sceneViewport = root.querySelector('.terence-brand-story__scene-viewport');
      let scrollTimer;
      sceneViewport?.addEventListener('scroll', () => {
        if (!isMobileV70()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const slides = visibleItems(allSlides);
          if (!slides.length) return;
          const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
          update(Math.round(sceneViewport.scrollLeft / step), false);
        }, 100);
      }, { passive: true });
      let drag = null;
      const isMobileV70 = () => root.classList.contains('terence-brand-story--v70') && window.matchMedia('(max-width: 749px)').matches;
      const finishDrag = (cancelled = false) => {
        if (!drag) return;
        const { pointerId, deltaX } = drag;
        drag = null;
        track.style.transition = '';
        if (sceneViewport.hasPointerCapture(pointerId)) sceneViewport.releasePointerCapture(pointerId);
        const threshold = Math.max(35, sceneViewport.clientWidth * 0.12);
        update(!cancelled && Math.abs(deltaX) >= threshold ? index + (deltaX < 0 ? 1 : -1) : index);
      };
      sceneViewport?.addEventListener('dragstart', (event) => {
        if (isMobileV70()) event.preventDefault();
      });
      sceneViewport?.addEventListener('pointerdown', (event) => {
        if (!isMobileV70() || event.pointerType !== 'mouse' || !event.isPrimary || event.button !== 0) return;
        drag = { pointerId: event.pointerId, startX: event.clientX, startY: event.clientY, deltaX: 0 };
        sceneViewport.setPointerCapture(event.pointerId);
        track.style.transition = 'none';
      });
      sceneViewport?.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.pointerId) return;
        const deltaX = event.clientX - drag.startX;
        const deltaY = event.clientY - drag.startY;
        if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 8) {
          finishDrag(true);
          return;
        }
        drag.deltaX = deltaX;
        if (Math.abs(deltaX) < 4) return;
        if (event.cancelable) event.preventDefault();
        const slides = visibleItems(allSlides);
        if (!slides.length) return;
        const step = slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        const atEdge = index === 0 && deltaX > 0 || index === slides.length - 1 && deltaX < 0;
        sceneViewport.scrollLeft = step * index - (atEdge ? deltaX * 0.25 : deltaX);
      });
      sceneViewport?.addEventListener('pointerup', (event) => {
        if (drag && event.pointerId === drag.pointerId) finishDrag();
      });
      sceneViewport?.addEventListener('pointercancel', (event) => {
        if (drag && event.pointerId === drag.pointerId) finishDrag(true);
      });
      sceneViewport?.addEventListener('lostpointercapture', (event) => {
        if (drag && event.pointerId === drag.pointerId) finishDrag(true);
      });
      const resize=()=>update(index);window.addEventListener('resize',resize);
      update(0);
    };
    document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('.terence-brand-story').forEach(root=>{initializedRoots.get(root)?.();initializedRoots.delete(root);});});
    document.querySelectorAll('.terence-brand-story').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('.terence-brand-story')) init(event.target);
      event.target.querySelectorAll('.terence-brand-story').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terence-v70-feature-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.TerenceFeatureCategoriesV2) return;
  const instances = new WeakMap();
  class Controller {
    constructor(root) {
      this.root = root;
      this.tabs = [...root.querySelectorAll('[data-feature-tab]')];
      this.panels = [...root.querySelectorAll('[data-feature-panel]')];
      this.strip = root.querySelector('.terence-feature-categories__tabs');
      this.abort = new AbortController();
      this.targets = new WeakMap();
      this.mobile = () => matchMedia('(max-width: 749px)').matches;
      this.behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      this.on = (el, type, fn, options = {}) => el?.addEventListener(type, fn, {...options, signal: this.abort.signal});
      this.tabs.forEach((tab, i) => {
        this.on(tab, 'click', () => this.select(tab, false));
        this.on(tab, 'keydown', event => {
          const keys = {ArrowLeft: Math.max(0, i - 1), ArrowRight: Math.min(this.tabs.length - 1, i + 1), Home: 0, End: this.tabs.length - 1};
          if (!(event.key in keys)) return;
          event.preventDefault(); this.select(this.tabs[keys[event.key]], true);
        });
      });
      this.panels.forEach(panel => {
        const rail = panel.querySelector('[data-feature-rail]');
        if (!rail) return;
        this.on(panel.querySelector('[data-feature-previous]'), 'click', () => this.move(panel, -1));
        this.on(panel.querySelector('[data-feature-next]'), 'click', () => this.move(panel, 1));
        this.on(rail, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.move(panel, event.key === 'ArrowRight' ? 1 : -1);
        });
        // Observe the gesture; native scrolling owns all movement. Never preventDefault.
        let gesture = null;
        this.on(rail, 'touchstart', event => {
          this.targets.delete(rail);
          gesture = this.mobile() && event.touches.length === 1 ? {
            x: event.touches[0].clientX, y: event.touches[0].clientY,
            left: rail.scrollLeft, max: Math.max(0, rail.scrollWidth - rail.clientWidth)
          } : null;
        }, {passive: true});
        this.on(rail, 'touchmove', event => {
          if (!gesture) return;
          if (event.touches.length !== 1 || Math.abs(event.touches[0].clientY - gesture.y) > Math.abs(event.touches[0].clientX - gesture.x) * .8) gesture = null;
        }, {passive: true});
        this.on(rail, 'touchend', event => {
          const start = gesture; gesture = null;
          const end = event.changedTouches?.[0];
          if (!start || !end) return;
          const dx = end.clientX - start.x, dy = end.clientY - start.y;
          if (Math.abs(dx) < Math.max(40, rail.clientWidth * .12) || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          // It must START at the boundary: reaching the last card cannot skip it.
          if (dx < 0 && start.left >= start.max - 3) this.adjacent(panel, 1);
          else if (dx > 0 && start.left <= 3) this.adjacent(panel, -1);
        }, {passive: true});
        this.on(rail, 'touchcancel', () => { gesture = null; }, {passive: true});
        this.on(rail, 'wheel', () => this.targets.delete(rail), {passive:true});
        this.on(rail, 'scroll', () => this.update(panel), {passive: true});
        this.mouseDrag(rail);
      });
      this.mouseDrag(this.strip);
      this.on(window, 'resize', () => this.panels.filter(p => !p.hidden).forEach(p => this.update(p)));
      this.select(this.tabs.find(t => t.getAttribute('aria-selected') === 'true') || this.tabs[0], false);
    }
    mouseDrag(rail) {
      if (!rail) return;
      let drag = null, moved = false;
      this.on(rail, 'pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.targets.delete(rail);
        drag = {x: e.clientX, left: rail.scrollLeft}; moved = false;
      });
      this.on(rail, 'pointermove', e => {
        if (!drag) return;
        if (Math.abs(e.clientX - drag.x) > 6) {
          moved = true; rail.setPointerCapture(e.pointerId); rail.classList.add('is-dragging');
          rail.scrollLeft = drag.left - (e.clientX - drag.x);
        }
      });
      const stop = e => { drag = null; rail.classList.remove('is-dragging'); if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId); };
      this.on(rail, 'pointerup', stop); this.on(rail, 'pointercancel', stop);
      this.on(rail, 'click', e => { if (moved) {e.preventDefault(); e.stopPropagation(); moved = false;} }, {capture: true});
      this.on(rail, 'dragstart', e => e.preventDefault());
    }
    positions(rail) {
      const cards = [...rail.querySelectorAll('.terence-feature-categories__rail-item')].filter(c => c.getBoundingClientRect().width > 0);
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      return [...new Set(cards.map(c => Math.max(0, Math.min(max, c.offsetLeft - cards[0].offsetLeft))))];
    }
    select(tab, focus, entry = 'start') {
      if (!tab) return;
      const id = tab.dataset.featureTab;
      this.tabs.forEach(t => { const active = t === tab; t.classList.toggle('is-active', active); t.setAttribute('aria-selected', String(active)); t.tabIndex = active ? 0 : -1; });
      this.root.querySelectorAll('[data-feature-intro]').forEach(el => { const active = el.dataset.featureIntro === id; el.hidden = !active; el.classList.toggle('is-active', active); });
      this.panels.forEach(panel => { const active = panel.dataset.featurePanel === id; panel.hidden = !active; panel.classList.toggle('is-active', active); });
      const panel = this.panels.find(p => p.dataset.featurePanel === id);
      const rail = panel?.querySelector('[data-feature-rail]');
      if (rail) { this.targets.delete(rail);rail.scrollTo({left: entry === 'end' ? rail.scrollWidth : 0, behavior: 'instant'}); this.update(panel); }
      if (this.strip) {
        const rect = tab.getBoundingClientRect(), parent = this.strip.getBoundingClientRect();
        if (rect.left < parent.left || rect.right > parent.right) this.strip.scrollTo({left: this.strip.scrollLeft + rect.left - parent.left - (parent.width - rect.width) / 2, behavior: this.behavior()});
      }
      if (focus) tab.focus({preventScroll: true});
    }
    adjacent(panel, direction) {
      const index = this.panels.indexOf(panel) + direction;
      if ((!this.mobile() && direction < 0) || index < 0 || index >= this.tabs.length) return;
      this.select(this.tabs[index], false, direction > 0 ? 'start' : 'end');
    }
    move(panel, direction) {
      const rail = panel.querySelector('[data-feature-rail]'), max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      if ((direction > 0 && rail.scrollLeft >= max - 3) || (direction < 0 && rail.scrollLeft <= 3)) { this.adjacent(panel, direction); return; }
      const positions = this.positions(rail);
      const pending=this.targets.get(rail);
      const index = pending??positions.reduce((best, p, i) => Math.abs(p - rail.scrollLeft) < Math.abs(positions[best] - rail.scrollLeft) ? i : best, 0);
      const target=Math.max(0, Math.min(positions.length - 1, index + direction));
      this.targets.set(rail,target);
      rail.scrollTo({left: positions[target], behavior: this.behavior()});
    }
    update(panel) {
      const rail = panel.querySelector('[data-feature-rail]'), max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const index = this.panels.indexOf(panel), left = Math.max(0, rail.scrollLeft);
      const pending=this.targets.get(rail);if(pending!==undefined&&Math.abs((this.positions(rail)[pending]??left)-left)<3)this.targets.delete(rail);
      const previous = panel.querySelector('[data-feature-previous]'), next = panel.querySelector('[data-feature-next]');
      if (previous) previous.disabled = left <= 3 && (!this.mobile() || index === 0);
      if (next) next.disabled = left >= max - 3 && index === this.panels.length - 1;
      const progress = panel.querySelector('[data-feature-progress]');
      if (progress) progress.style.transform = `scaleX(${max ? Math.max(.12, Math.min(1, left / max)) : 1})`;
    }
    destroy() { this.abort.abort(); }
  }
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-terence-feature-categories]')];
    if (scope.matches?.('[data-terence-feature-categories]')) roots.push(scope);
    roots.forEach(root => { if (!instances.has(root)) instances.set(root, new Controller(root)); });
  }
  window.TerenceFeatureCategoriesV2 = {init, selectBlock(block) {const root = block.closest('[data-terence-feature-categories]'), panel = block.closest('[data-feature-panel]'); if (root && panel) instances.get(root)?.select(root.querySelector(`[data-feature-tab="${panel.dataset.featurePanel}"]`), false);}};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true}); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-terence-feature-categories]').forEach(root => {instances.get(root)?.destroy(); instances.delete(root);}));
  document.addEventListener('shopify:block:select', e => window.TerenceFeatureCategoriesV2.selectBlock(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v70-pro-upgrades"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(window.TerenceV70Upgrades)return;
  const instances=new WeakMap();
  function init(root){
    if (!root || root.dataset.v70InteractionReady) return;
    root.dataset.v70InteractionReady = 'true';
    const abort=new AbortController(),cleanup=[];
    const on=(target,type,fn,options={})=>target.addEventListener(type,fn,{...options,signal:abort.signal});
    instances.set(root,()=>{abort.abort();cleanup.forEach(fn=>fn());delete root.dataset.v70InteractionReady;});
    const track = root.querySelector('[data-upgrades-track]');
    const rail = root.querySelector('[data-upgrades-rail]');
    const previousButton = root.querySelector('[data-upgrades-previous]');
    const nextButton = root.querySelector('[data-upgrades-next]');
    if (track && rail) {
      let railDragging = false;
      let scrollFrame = 0;
      let railFrame = 0;
      cleanup.push(()=>{cancelAnimationFrame(scrollFrame);cancelAnimationFrame(railFrame);});
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const cardStep = () => {
        const card = track.querySelector('.v70-pro-upgrades__card');
        if (!card) return 300;
        const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const updateArrows = () => {
        if (!previousButton || !nextButton) return;
        const maximum = maxScroll();
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximum - 2 || maximum === 0;
      };
      const updateRail = () => {
        if (railDragging || railFrame) return;
        railFrame = window.requestAnimationFrame(() => {
          railFrame = 0;
          const maximum = maxScroll();
          rail.value = maximum > 0 ? (track.scrollLeft / maximum) * 100 : 0;
          rail.disabled = maximum === 0;
          updateArrows();
        });
      };
      const beginRailDrag = () => {
        railDragging = true;
        track.classList.add('is-rail-dragging');
      };
      const endRailDrag = () => {
        if (!railDragging) return;
        railDragging = false;
        track.classList.remove('is-rail-dragging');
        updateRail();
      };
      on(rail,'input', () => {
        const target = maxScroll() * (Number(rail.value) / 100);
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          track.scrollLeft = target;
        });
      });
      on(rail,'pointerdown', beginRailDrag);
      on(rail,'pointerup', endRailDrag);
      on(rail,'pointercancel', endRailDrag);
      on(window,'pointerup', endRailDrag);
      on(window,'pointercancel', endRailDrag);
      on(rail,'change', endRailDrag);
      on(rail,'blur', endRailDrag);
      previousButton&&on(previousButton,'click', () => {
        track.scrollBy({ left: -cardStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      nextButton&&on(nextButton,'click', () => {
        track.scrollBy({ left: cardStep(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      on(track,'scroll', updateRail, { passive: true });
      on(window,'resize', updateRail);
      updateRail();
    }

    const video = root.querySelector('[data-upgrades-video]');
    if (video && 'IntersectionObserver' in window) {
      const playThreshold = 0.75;
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= playThreshold) {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.controls = false;
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, playThreshold, 1] });
      videoObserver.observe(video);
      cleanup.push(()=>{videoObserver.disconnect();video.pause();});
    }

  }
  function scan(scope=document){scope.querySelectorAll('.v70-pro-upgrades').forEach(init);if(scope.matches?.('.v70-pro-upgrades'))init(scope);}
  window.TerenceV70Upgrades={init:scan};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(),{once:true});else scan();
  document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.v70-pro-upgrades').forEach(root=>{instances.get(root)?.();instances.delete(root);}));
})();

  } catch(e) { console.error(e); }
})();
})();
